<template>
  <div :class="b()">
    <div :class="b('minus')" @click="decreaseValue">-</div>
    <input type="text" :class="b('field')" v-model="currentValue">
    <div :class="b('plus')" @click="increaseValue">+</div>
  </div>
</template>

<script>
    const COMPONENT_NAME = "number-counter";

    export default {
        name: COMPONENT_NAME,
        props: ['value', 'minValue'],
        data() {
            return {
                currentValue: null,
                min: 1
            };
        },
        created() {
            this.currentValue = this.value;

            if (!_.isUndefined(this.minValue) && !_.isNull(this.minValue)) {
                this.min = this.minValue;
            }
        },
        methods: {
            qwe() {
                this.$parent.sumPriceText('maxPrice');
            },
            decreaseValue() {
              // this.$parent.sumPriceText('maxPrice');
              if (this.currentValue > this.min) {
                    this.currentValue--;
                }
            },
            increaseValue() {
                this.currentValue++;
                // this.$parent.sumPriceText('maxPrice');
            }
        },
        watch: {
            currentValue: {
                handler(newValue) {
                    this.$emit('input', newValue);
                  this.$parent.sumPriceText();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
  .number-counter {
    display: flex;
    max-width: 130px;

    &__field {
      padding-left: 25px;
      padding-right: 25px;
      width: 100%;
      height: 40px;
      border: 1px solid #c9ced1;
      border-radius: 0;
      text-align: center;
      color: #3f464e;
      font-size: 14px;
      font-weight: 400;
    }

    &__plus, &__minus {
      width: 40px;
      height: 40px;
      text-align: center;
      line-height: 38px;
      font-weight: 500;
      font-size: 20px;
      border: 1px solid #c9ced1;
    }

    &__plus:hover, &__minus:hover {
      cursor: pointer;
      -webkit-transition: background 0.35s ease;
      transition: background 0.35s ease;
    }

    &__plus {
      /*color: #ef2c30;*/
      /*border-left: none;*/
      /*border-radius: 0 5px 5px 0;*/
    }

    &__minus {
      /*color: #009eff;*/
      /*border-right: none;*/
      /*border-radius: 5px 0 0 5px;*/
    }
  }
</style>